import { useLatestMgoSystemState, useMgoClient } from '@mgonetwork/dapp-kit';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { MgoClient, type TransactionFilter } from '@mgonetwork/mango.js/client';
import { ApyByValidator, roundFloat } from '@mgonetwork/core';

import { useFullNodeRpcClient } from './useFullNodeRpc';

export const DEFAULT_TRANSACTIONS_LIMIT = 20;
const DEFAULT_APY_DECIMALS = 2;
const MINIMUM_THRESHOLD = 0.001;

export function useGetFullNodeValidatorsApy() {
	const client = useFullNodeRpcClient();

	const { data: systemStateResponse, isFetched } = useLatestMgoSystemState();

	return useQuery({
		queryKey: ['get-fullnodde-rolling-average-apys'],
		queryFn: () => client.getValidatorsApy(),
		enabled: isFetched,
		select: (validatorApys) => {
			// check if stakeSubsidyStartEpoch is greater than current epoch, flag for UI to show ~0% instead of 0%
			const currentEpoch = Number(systemStateResponse?.epoch);
			const stakeSubsidyStartEpoch = Number(systemStateResponse?.stakeSubsidyStartEpoch);

			const isStakeSubsidyStarted = currentEpoch > stakeSubsidyStartEpoch;

			return validatorApys?.apys.reduce((acc, { apy, address }) => {
				acc[address] = {
					apy: roundFloat(apy * 100, DEFAULT_APY_DECIMALS),
					isApyApproxZero: !isStakeSubsidyStarted || apy < MINIMUM_THRESHOLD,
				};
				return acc;
			}, {} as ApyByValidator);
		},
	});
}
